import Card from "components/Card/Card";
import PropTypes from "prop-types";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import MailOutline from "@material-ui/icons/MailOutline";
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";
import CardBody from "components/Card/CardBody";
import CustomInput from "components/CustomInput/CustomInput.js";
import { yuuApi } from "functions/apis";
import Button from "components/CustomButtons/Button.js";
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";

const useStyles = makeStyles(styles);

export default function CreateYuuTransaction(props) {
  const createYuuTransactionSignal = new AbortController();

  const [redirect, setRedirect] = React.useState(false);
  const [disabled, setDisabled] = React.useState(false);
  const [body, setBody] = React.useState({
    tomoId: "",
    applicationID: "",
    referenceId: "",
    referenceNo: "",
    description: "",
    totalAmount: 0,
    paidAmount: 0,
    pwpAmount: 0
  });
  const [applicationList, setApplicationList] = useState([]);

  useEffect(() => {
    yuuApi
      .get("Applications", {
        signal: createYuuTransactionSignal.signal
      })
      .then(resp => {
        setApplicationList(resp);
      });
  }, []);

  useEffect(() => {
    setBody(prev => ({
      ...prev,
      totalAmount:
        (prev.paidAmount ? Number(prev.paidAmount) : 0) +
        (prev.pwpAmount ? Number(prev.pwpAmount) : 0)
    }));
  }, [body.paidAmount, body.pwpAmount]);

  const handleTomoIdChanged = e =>
    setBody({
      ...body,
      tomoId: e.target.value === "" ? null : e.target.value
    });

  const handleApplicationIDChanged = e =>
    setBody({
      ...body,
      applicationID: e.target.value === "" ? null : e.target.value
    });

  const handleReferenceIDChanged = e =>
    setBody({
      ...body,
      referenceId: e.target.value === "" ? null : e.target.value
    });

  const handleReferenceNoChanged = e =>
    setBody({
      ...body,
      referenceNo: e.target.value === "" ? null : e.target.value
    });

  const handleDescriptionChanged = e =>
    setBody({
      ...body,
      description: e.target.value === "" ? null : e.target.value
    });

  const handlePaidAmountChanged = e =>
    setBody({
      ...body,
      paidAmount: e.target.value === 0 ? null : e.target.value
    });

  const handlePwpAmountChanged = e =>
    setBody({
      ...body,
      pwpAmount: e.target.value === 0 ? null : e.target.value
    });

  const handleSubmit = e => {
    e.preventDefault();
    setDisabled(true);

    yuuApi
      .post("Transactions", body, {
        signal: createYuuTransactionSignal.signal
      })
      .then(() => {
        setRedirect(true);
      })
      .catch(err => {
        console.log(err);
        setDisabled(false);
      });
  };

  const classes = useStyles();
  return redirect ? (
    <Redirect to={"/admin/YuuTransaction/Enqueued"} />
  ) : (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              {`CREATE YUU TRANSACTION`}
            </h4>
          </CardHeader>
          <CardBody>
            <Button onClick={() => props.history.goBack()} value="Back">
              BACK
            </Button>
            <form onSubmit={handleSubmit}>
              <GridContainer spacing={3}>
                {applicationList.length > 0 ? (
                  <GridItem xs={6}>
                    <FormControl
                      fullWidth
                      className={classes.selectFormControl}
                    >
                      <InputLabel
                        htmlFor="selApplicationID"
                        className={classes.selectLabel}
                      >
                        Application
                      </InputLabel>
                      <Select
                        MenuProps={{
                          className: classes.selectMenu
                        }}
                        classes={{
                          select: classes.select
                        }}
                        value={
                          body.applicationID === null ? "" : body.applicationID
                        }
                        onChange={handleApplicationIDChanged}
                      >
                        {applicationList.map(application => {
                          return (
                            <MenuItem
                              classes={{
                                root: classes.selectMenuItem,
                                selected: classes.selectMenuItemSelected
                              }}
                              value={application.id}
                              key={application.id}
                            >
                              <b>{application.name}</b>
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </GridItem>
                ) : null}
                <GridItem xs={6} md={6}>
                  <CustomInput
                    labelText="Tomo ID"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      onChange: handleTomoIdChanged,
                      value: body.tomoId === null ? "" : body.tomoId
                    }}
                  />
                </GridItem>
                <GridItem xs={6} md={6}>
                  <CustomInput
                    labelText="Reference ID"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      onChange: handleReferenceIDChanged,
                      value: body.referenceId === null ? "" : body.referenceId
                    }}
                  />
                </GridItem>
                <GridItem xs={6} md={6}>
                  <CustomInput
                    labelText="Reference No"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      onChange: handleReferenceNoChanged,
                      value: body.referenceNo === null ? "" : body.referenceNo
                    }}
                  />
                </GridItem>
                <GridItem xs={12}>
                  <CustomInput
                    labelText="Description"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      onChange: handleDescriptionChanged,
                      value: body.description === null ? "" : body.description
                    }}
                  />
                </GridItem>
                <GridItem xs={6}>
                  <CustomInput
                    labelText="Paid Amount"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "number",
                      onChange: handlePaidAmountChanged,
                      value: body.paidAmount === null ? "" : body.paidAmount
                    }}
                  />
                </GridItem>
                <GridItem xs={6}>
                  <CustomInput
                    labelText="Pwp Amount"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "number",
                      onChange: handlePwpAmountChanged,
                      value: body.pwpAmount === null ? "" : body.pwpAmount
                    }}
                  />
                </GridItem>
                <GridItem xs={12}>
                  <CustomInput
                    labelText="Total Amount"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "number",
                      disabled: true,
                      value: body.totalAmount === null ? "" : body.totalAmount
                    }}
                  />
                </GridItem>
              </GridContainer>
              <Button
                disabled={disabled}
                color="rose"
                type="submit"
                value="Submit"
              >
                Submit
              </Button>
            </form>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}

CreateYuuTransaction.propTypes = {
  history: PropTypes.object
};
